import { useTranslator } from '@Localization';
import { MenuItem } from '@mui/joy';
import { ReactElement } from 'react';
interface IProps {
  onClick: () => void;
}

export const UpdateWorkspaceTimeZoneMenuItem = ({ onClick }: IProps): ReactElement => {
  const { t } = useTranslator();
  return <MenuItem onClick={onClick}>{t('update_workspace_timezone')}</MenuItem>;
};
